<template>
  <div class="min-h-screen bg-background-light">
    <header class="fixed top-0 left-0 right-0 z-50 bg-white border-b border-primary/10">
      <div class="max-w-7xl mx-auto px-6 lg:px-20 h-16 flex items-center justify-between">
        <RouterLink class="flex items-center gap-3" to="/">
          <div class="size-10 bg-primary flex items-center justify-center rounded-xl text-white">
            <span class="material-symbols-outlined text-2xl">local_shipping</span>
          </div>
          <div class="leading-tight">
            <div class="text-primary text-sm font-black tracking-tight uppercase">Guépard Express</div>
            <div class="text-slate-500 text-xs font-semibold">Plateforme client</div>
          </div>
        </RouterLink>

        <div class="flex items-center gap-3">
          <template v-if="auth.isAuthenticated">
            <div class="hidden sm:flex items-center gap-3 px-4 h-10 rounded-lg bg-slate-50 border border-primary/5">
              <div class="size-6 rounded-full bg-primary/10 text-primary flex items-center justify-center">
                <span class="material-symbols-outlined text-base">person</span>
              </div>
              <span class="text-sm font-black text-slate-700">{{ auth.user?.name || 'Client' }}</span>
            </div>
            <button
              class="h-10 px-4 rounded-lg border border-primary/20 text-primary font-bold hover:bg-primary/5 transition-colors"
              type="button"
              @click="onLogout"
            >
              Déconnexion
            </button>
          </template>
          <RouterLink
            v-else
            class="h-10 px-4 rounded-lg bg-primary text-white font-bold flex items-center shadow-lg shadow-primary/20"
            to="/login"
            >Connexion</RouterLink
          >
        </div>
      </div>
    </header>

    <div class="pt-16">
      <div class="max-w-7xl mx-auto px-6 lg:px-20 py-8">
        <div v-if="!auth.isAuthenticated" class="rounded-2xl bg-white border border-primary/10 p-10">
          <div class="max-w-xl">
            <h1 class="text-3xl font-black tracking-tight text-slate-900">Accès à votre espace</h1>
            <p class="mt-3 text-slate-600 font-medium">
              Connectez-vous pour créer des expéditions, comparer les transporteurs, imprimer des étiquettes et suivre vos colis.
            </p>
            <div class="mt-6 flex gap-3">
              <RouterLink class="h-12 px-6 rounded-xl bg-primary text-white font-bold flex items-center" to="/login"
                >Se connecter</RouterLink
              >
              <RouterLink class="h-12 px-6 rounded-xl border border-primary/20 text-primary font-bold flex items-center" to="/"
                >Retour au site</RouterLink
              >
            </div>
          </div>
        </div>

        <div v-else class="grid grid-cols-1 lg:grid-cols-[260px_1fr] gap-8">
          <aside class="lg:sticky lg:top-24 h-fit">
            <div class="rounded-2xl bg-white border border-primary/10 p-4">
              <div class="px-3 py-2 text-xs font-black tracking-widest uppercase text-slate-400">Navigation</div>
              <nav class="mt-2 space-y-1">
                <RouterLink class="nav-item" to="/app/dashboard">
                  <span class="material-symbols-outlined text-xl">space_dashboard</span>
                  Tableau de bord
                </RouterLink>
                <RouterLink class="nav-item" to="/app/shipments">
                  <span class="material-symbols-outlined text-xl">local_shipping</span>
                  Expéditions
                </RouterLink>
                <RouterLink class="nav-item" to="/app/commandes">
                  <span class="material-symbols-outlined text-xl">inventory_2</span>
                  Mes colis
                </RouterLink>
                <RouterLink v-if="auth.isAdmin" class="nav-item" to="/admin/regroupements">
                  <span class="material-symbols-outlined text-xl">admin_panel_settings</span>
                  Administration
                </RouterLink>
                <a class="nav-item opacity-60 pointer-events-none" href="#">
                  <span class="material-symbols-outlined text-xl">sell</span>
                  Tarifs
                </a>
                <a class="nav-item opacity-60 pointer-events-none" href="#">
                  <span class="material-symbols-outlined text-xl">receipt_long</span>
                  Étiquettes
                </a>
                <a class="nav-item opacity-60 pointer-events-none" href="#">
                  <span class="material-symbols-outlined text-xl">travel_explore</span>
                  Suivi
                </a>
                <a class="nav-item opacity-60 pointer-events-none" href="#">
                  <span class="material-symbols-outlined text-xl">settings</span>
                  Paramètres
                </a>
              </nav>
            </div>
          </aside>

          <main>
            <RouterView />
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth'

export default {
  name: 'AppShell',
  computed: {
    auth() {
      return useAuthStore()
    }
  },
  mounted() {
    // Rafraîchir les infos utilisateur au chargement si un token existe
    if (this.auth.token) {
      this.auth.fetchMe().catch(err => {
        console.error('Erreur rafraîchissement utilisateur:', err)
      })
    }
  },
  methods: {
    onLogout() {
      this.auth.logout()
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  font-weight: 700;
  color: rgb(51 65 85);
  transition: background-color 150ms ease, color 150ms ease;
}
.nav-item:hover {
  background: rgba(26, 34, 127, 0.06);
  color: rgb(26 34 127);
}
.router-link-active.nav-item {
  background: rgba(26, 34, 127, 0.12);
  color: rgb(26 34 127);
}
</style>
